/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-param-reassign */

import React from 'react';
import styled, { css } from 'styled-components';
import Content from 'TMComponents/Content';
import ImageDynamic from 'TMComponents/ImageDynamic';
import imageProps from 'TMPropTypes/imageProps';
import { string, array, shape } from 'prop-types';
import cardBackgroundOption from 'TMComponents/GlobalStyle/cardBackgroundStyles';
import commonOptionsPropType from 'TMPropTypes/commonOptionsProps';
import ComponentMapper from 'TMComponents/ComponentMapper';
import { breakpoints } from 'TMConstants';

const baseCardStyles = css`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 350px;
    ${({ sizing }) => sizing && `width: ${sizing};`}

    max-width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    border-radius: 32px;
    ${({ theme }) => `
        box-shadow: ${theme.colorSystem.shadows[10]};
    `}
`;

const CardBackground = styled.div`
    ${baseCardStyles}
    ${cardBackgroundOption}

    padding: 32px 20px 0 20px;
    margin: 0 20px;

    @media (max-width: ${breakpoints.mobileTablet}px) {
        margin-left: 0;
        margin-right: 0;

        &:not(:last-child) {
            margin-bottom: 20px;
        }
    }

    ${({ hasImage }) => !hasImage && `padding-bottom: 32px;`}
    overflow: hidden;
`;

const Corner = styled.div`
    position: absolute;
    margin: 40px 20px;

    right: 0;
    top: 0;
`;

const StyledContent = styled(Content)`
    display: flex;
    flex-direction: column;
    flex: 1;
    /* This finds the parent (SharedOptions wrapper) of 
    DynamicSeparator component  */
    *:has(.dynamic-separator) {
        margin-top: auto;
    }
`;

const Image = styled(ImageDynamic)`
    margin-left: -20px;
    margin-right: -20px;
`;

const LargeCard = ({
    image,
    content,
    commonOptions,
    sizing,
    topRightCorner = []
}) => {
    return (
        <CardBackground
            cardBackgroundColor={commonOptions?.cardBackgroundColor}
            sizing={sizing}
            hasImage={!!image}>
            {topRightCorner[0] && (
                <Corner>
                    <ComponentMapper {...topRightCorner[0]} />
                </Corner>
            )}
            <StyledContent noSidePadding content={content} />
            {image && <Image imageData={image} objectPosition="0% 50%" />}
        </CardBackground>
    );
};

export default LargeCard;

LargeCard.propTypes = {
    content: array.isRequired,
    sizing: string,
    image: shape(imageProps),
    ...commonOptionsPropType
};
